<template>
    <plus-order :otherChannelId="1212121"></plus-order>
</template>
<script>
import PlusOrder from '@/pages/plusOrder/plusOrder'
export default {
  name: 'opening-card-record',
  data () {
    return {
      queryParams: {}
    }
  },
  components: { PlusOrder },
  filters: {
    roleFilter (value) {
      let filter_value = '暂无'
      switch (value) {
        case 1:// 普通会员
          filter_value = '普通会员'
          break
        case 2:// 经纪人
          filter_value = '经纪人'
          break
        case 3:// 合伙人
          filter_value = '合伙人'
          break
      }
      return filter_value
    }
  }
}
</script>
